import MESSAGE_KEY from '../login-message-key';

export default {
  [MESSAGE_KEY.LOGIN_TITLE]: '飞识 (广州)',
  [MESSAGE_KEY.LOGIN_SUB_TITLE]: 'Pyxis (GZ) Website',
  [MESSAGE_KEY.LOGIN_FORM_TITLE]: '账户登录',
  [MESSAGE_KEY.ADA_TEXTBOX_PLACEHOLDER]: '请输入卡号',
  [MESSAGE_KEY.PHONE_NUMBER_TEXTBOX_PLACEHOLDER]: '请输入卡号绑定的手机号',
  [MESSAGE_KEY.CAPTCHA_TEXTBOX_PLACEHOLDER]: '请输入手机验证码',
  [MESSAGE_KEY.TERM_DESCRIPTION]: '我已阅读并同意{userAg}和{privacyStrategy}的所有内容。',
  [MESSAGE_KEY.TERM_DESCRIPTION_USER_AGREEMENT]: '用户协议',
  [MESSAGE_KEY.TERM_DESCRIPTION_PRIVACY_STRATEGY]: '隐私政策',
  [MESSAGE_KEY.GREET_TXT]: '您好',
  [MESSAGE_KEY.COPYRIGHT_DESCRIPTION]: '版权为飞识（广州）信息技术有限公司所有<br />未经许可不得转载或链接，粤ICP备2022080943号',

  [MESSAGE_KEY.LOGIN_BUTTON]: '登录',
  [MESSAGE_KEY.GET_CAPTCHA_BUTTON]: '获取验证码',
  [MESSAGE_KEY.RE_GET_CAPTCHA_BUTTON]: '{times}秒后重发',
  [MESSAGE_KEY.INTELLIGENT_VERIFICATION_BUTTON]: '请进行智能验证',
  [MESSAGE_KEY.CLOSE_BUTTON]: '关闭',
  [MESSAGE_KEY.LOGOUT_BUTTON]: '退出',

  [MESSAGE_KEY.CAPTCHA_HAS_BEEN_SENT_TIPS]: '验证码已发出，请注意查收短信，如果没有收到，你可以在等待时间结束后要求系统重新发送',
  [MESSAGE_KEY.START_INTELLIGENT_VERIFICATION_TIPS]: '点击按钮开始智能验证',
  [MESSAGE_KEY.FAIL_INTELLIGENT_VERIFICATION_TIPS]: '验证失败，请在此点击按钮刷新',
  [MESSAGE_KEY.SUCCESS_INTELLIGENT_VERIFICATION_TIPS]: '验证成功',
  [MESSAGE_KEY.SCANING_INTELLIGENT_VERIFICATION_TIPS]: '智能检测中',

  [MESSAGE_KEY.NETWORK_ERROR]: '网络繁忙，请稍后再试',
  [MESSAGE_KEY.TERM_REQUIRED_ERROR]: '请阅读并同意《用户协议》和《隐私政策》',
  [MESSAGE_KEY.CAPTCHA_REQUIRED_ERROR]: '验证码不能为空',
  [MESSAGE_KEY.ADA_NUMBER_REQUIRED_ERROR]: '卡号不能为空',
  [MESSAGE_KEY.PHONE_NUMBER_REQUIRED_ERROR]: '电话号不能为空',
  [MESSAGE_KEY.SUCCESS_INTELLIGENT_VERIFICATION_TIPS]: '验证成功',
  [MESSAGE_KEY.FAIL_INTELLIGENT_VERIFICATION_TIPS]: '验证失败，请在此点击按钮刷新',
};
